module.exports = __webpack_public_path__ + "static/share-8340833354050b32566d6edb006c8c22.jpg";